/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 6/1/2023
 */
import React, { useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom"
import gsap from "gsap"
import {
  Button,
} from "@mui/material"
import "./styles/ErrorPage.styles.scss"
import LoginIcon from "@mui/icons-material/Login"

const SessionTimeout = () => {
  const navigate = useNavigate()
  const cog1Ref = useRef(null)
  const cog2Ref = useRef(null)
  const wrongParaRef = useRef(null)

  const handleLogin= ()=>{
     navigate("/login")
  }

  useEffect(() => {
    const t1 = gsap.timeline()
    const t2 = gsap.timeline()
    const t3 = gsap.timeline()

    t1.to(cog1Ref.current, {
      transformOrigin: "50% 50%",
      rotation: "+=360",
      repeat: -1,
      ease: "linear.none",
      duration: 8,
    })

    t2.to(cog2Ref.current, {
      transformOrigin: "50% 50%",
      rotation: "-=360",
      repeat: -1,
      ease: "linear.none",
      duration: 8,
    })

    t3.fromTo(
      wrongParaRef.current,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 1,
        stagger: {
          repeat: -1,
          yoyo: true,
        },
      }
    )
  }, [])

  return (
    <div className="container">
      <div className="cog-wheel1">
        <div className="cog1" ref={cog1Ref}>
          <div className="top"></div>
          <div className="down"></div>
          <div className="left-top"></div>
          <div className="left-down"></div>
          <div className="right-top"></div>
          <div className="right-down"></div>
          <div className="left"></div>
          <div className="right"></div>
        </div>
      </div>

      <div className="cog-wheel2">
        <div className="cog2" ref={cog2Ref}>
          <div className="top"></div>
          <div className="down"></div>
          <div className="left-top"></div>
          <div className="left-down"></div>
          <div className="right-top"></div>
          <div className="right-down"></div>
          <div className="left"></div>
          <div className="right"></div>
        </div>
      </div>

      <p className="wrong-para">
        Uh Oh! Sorry, Your Session Has Expired Due To Being Idle For Too Long
      </p>
      <p className="wrong-para2" ref={wrongParaRef}>
        You will have to Login again
      </p>
      <p className="wrong-para3">
        <Button
          variant="contained"
          color="primary"
          sx={{ borderRadius: 28 }}
          size="large"
          onClick={handleLogin}
          endIcon={<LoginIcon />}
        >
          Login
        </Button>
      </p>
    </div>
  )
}

export default SessionTimeout
